// ===========================
// MJ GROUP REAL ESTATE — Scripts
// Efectos · Parallax · Reveal · Counter · Tilt 3D · Ripple
// ===========================

// ===== PAGE LOADER =====
const loader = document.createElement('div');
loader.className = 'page-loader';
loader.innerHTML = `
  <div class="loader__logo">
    <span class="nav__logo-mj">MJ</span>
    <span class="nav__logo-group">
      <span class="nav__logo-group-name">GROUP</span>
      <span class="nav__logo-sub">Real Estate</span>
    </span>
  </div>
  <div class="loader__bar"><div class="loader__bar-fill"></div></div>
`;
document.body.prepend(loader);

window.addEventListener('load', () => {
  setTimeout(() => loader.classList.add('loaded'), 750);
  setTimeout(() => loader.remove(), 1500);
});

// ===== NAV SCROLL =====
const nav = document.getElementById('nav');
window.addEventListener('scroll', () => {
  nav.classList.toggle('scrolled', window.scrollY > 60);
}, { passive: true });

// ===== MOBILE MENU =====
const navToggle = document.getElementById('navToggle');
const navMenu   = document.getElementById('navMenu');

navToggle.addEventListener('click', () => {
  navToggle.classList.toggle('open');
  navMenu.classList.toggle('open');
});

navMenu.querySelectorAll('a').forEach(link => {
  link.addEventListener('click', () => {
    navToggle.classList.remove('open');
    navMenu.classList.remove('open');
  });
});

// ===== HERO PARALLAX =====
const hero = document.querySelector('.hero');
if (hero) {
  window.addEventListener('scroll', () => {
    const scrollY = window.scrollY;
    if (scrollY < window.innerHeight) {
      hero.style.backgroundPositionY = `calc(50% + ${scrollY * 0.3}px)`;
    }
  }, { passive: true });
}

// ===== SECTION TAG — SUBRAYADO ANIMADO =====
const tagObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('tag-active');
      tagObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.9 });

document.querySelectorAll('.section__tag').forEach(tag => tagObserver.observe(tag));

// ===== SCROLL REVEAL =====
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.1, rootMargin: '0px 0px -44px 0px' });

function assignReveal(selector, direction, stagger = false) {
  document.querySelectorAll(selector).forEach((el, i) => {
    el.classList.add('reveal', `reveal--${direction}`);
    if (stagger) {
      el.classList.add(`reveal-delay-${Math.min(i + 1, 6)}`);
    }
    revealObserver.observe(el);
  });
}

assignReveal('.category-card',       'scale', true);
assignReveal('.catalog-card--grid',  'up',    true);
assignReveal('.stat',                'up',    true);
assignReveal('.about__feature',      'left',  true);
assignReveal('.contact__channel',    'left',  true);
assignReveal('.catalog-card--featured', 'up', false);
assignReveal('.about__img',          'left',  false);
assignReveal('.about__content',      'right', false);
assignReveal('.contact__info',       'left',  false);
assignReveal('.contact__form',       'right', false);
assignReveal('.section__title',      'fade',  false);
assignReveal('.catalog__more',       'fade',  false);
assignReveal('.admin-service__item', 'left',  true);
assignReveal('.admin-service__img',  'right', false);
assignReveal('.admin-service__content .section__title', 'fade', false);

// ===== COUNTER ANIMATION =====
function animateCounter(el) {
  const text     = el.textContent.trim();
  const hasPlus  = text.includes('+');
  const target   = parseInt(text.replace(/[^0-9]/g, ''), 10);
  if (isNaN(target)) return;

  const duration  = 1900;
  const startTime = performance.now();

  function update(now) {
    const progress = Math.min((now - startTime) / duration, 1);
    const eased    = 1 - Math.pow(1 - progress, 3); // ease-out cubic
    el.textContent = Math.round(eased * target) + (hasPlus ? '+' : '');
    if (progress < 1) requestAnimationFrame(update);
  }

  requestAnimationFrame(update);
}

const counterObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      animateCounter(entry.target);
      counterObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.6 });

document.querySelectorAll('.stat__number').forEach(el => counterObserver.observe(el));

// ===== 3D TILT EN TARJETAS (solo desktop/mouse) =====
function initTilt(selector) {
  if (isTouchDevice()) return; // no tilt en móvil
  document.querySelectorAll(selector).forEach(card => {
    card.addEventListener('mousemove', (e) => {
      const rect = card.getBoundingClientRect();
      const x    = (e.clientX - rect.left) / rect.width  - 0.5;
      const y    = (e.clientY - rect.top)  / rect.height - 0.5;
      card.style.setProperty('--rotY', `${x * 7}deg`);
      card.style.setProperty('--rotX', `${-y * 7}deg`);
    }, { passive: true });

    card.addEventListener('mouseleave', () => {
      card.style.setProperty('--rotY', '0deg');
      card.style.setProperty('--rotX', '0deg');
    });
  });
}

initTilt('.category-card');
initTilt('.catalog-card--grid');

// ===== RIPPLE EN BOTONES =====
document.querySelectorAll('.btn').forEach(btn => {
  btn.addEventListener('click', (e) => {
    const rect   = btn.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'btn-ripple';
    const size = Math.max(rect.width, rect.height);
    ripple.style.width  = size + 'px';
    ripple.style.height = size + 'px';
    ripple.style.left   = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top    = (e.clientY - rect.top  - size / 2) + 'px';
    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 700);
  });
});

// ===== EFECTO MAGNÉTICO EN BOTONES PRINCIPALES (solo desktop) =====
if (!isTouchDevice()) {
  document.querySelectorAll('.btn--primary:not(.btn--full):not(.btn--sm), .btn--outline:not(.btn--full)').forEach(btn => {
    btn.addEventListener('mousemove', (e) => {
      const rect = btn.getBoundingClientRect();
      const x    = (e.clientX - rect.left  - rect.width  / 2) * 0.16;
      const y    = (e.clientY - rect.top   - rect.height / 2) * 0.16;
      btn.style.transform = `translate(${x}px, ${y}px) translateY(-2px)`;
    });
    btn.addEventListener('mouseleave', () => {
      btn.style.transform = '';
    });
  });
}

// ===== FILTROS COMBINABLES (Negocio + Ubicación + Tipo) =====
const propCards = document.querySelectorAll('.catalog-card');

// Estado activo por grupo
const activeFilters = {
  negocio:  'all',
  location: 'all',
  inmueble: 'all',
  estrato:  'all'
};

// Click handler por botón de filtro
document.querySelectorAll('.filter-btn[data-group]').forEach(btn => {
  btn.addEventListener('click', () => {
    const group  = btn.dataset.group;
    const filter = btn.dataset.filter;

    // Activar solo el botón seleccionado dentro de su grupo
    document.querySelectorAll(`.filter-btn[data-group="${group}"]`)
      .forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    activeFilters[group] = filter;
    applyFilters();
  });
});

// Reset filtros
const resetBtn = document.getElementById('filterReset');
if (resetBtn) {
  resetBtn.addEventListener('click', () => {
    Object.keys(activeFilters).forEach(k => activeFilters[k] = 'all');
    document.querySelectorAll('.filter-btn[data-group]').forEach(b => {
      b.classList.toggle('active', b.dataset.filter === 'all');
    });
    applyFilters();
  });
}

function matchesCard(card) {
  // Grupo "Negocio" considera data-type (venta/alquiler/airbnb) y data-style (amoblado/tradicional)
  const matchNegocio = activeFilters.negocio === 'all'
    || card.dataset.type  === activeFilters.negocio
    || card.dataset.style === activeFilters.negocio;

  const matchLocation = activeFilters.location === 'all'
    || card.dataset.location === activeFilters.location;

  const matchInmueble = activeFilters.inmueble === 'all'
    || card.dataset.inmueble === activeFilters.inmueble;

  const matchEstrato = activeFilters.estrato === 'all'
    || card.dataset.estrato === activeFilters.estrato;

  return matchNegocio && matchLocation && matchInmueble && matchEstrato;
}

function applyFilters() {
  let visibleIdx = 0;

  propCards.forEach(card => {
    if (matchesCard(card)) {
      card.style.display = '';
      const delay = visibleIdx * 60;
      visibleIdx++;
      setTimeout(() => {
        card.style.opacity   = '1';
        card.style.transform = '';
      }, delay);
    } else {
      card.style.opacity   = '0';
      card.style.transform = 'translateY(18px) scale(0.97)';
      setTimeout(() => { card.style.display = 'none'; }, 360);
    }
  });

  // Contador de resultados
  const countEl = document.getElementById('filterCount');
  if (countEl) {
    if (visibleIdx === 0) {
      countEl.textContent = 'Sin resultados para esta selección';
      countEl.classList.add('filter-count--empty');
    } else {
      const plural = visibleIdx !== 1;
      countEl.textContent = `${visibleIdx} propiedad${plural ? 'es' : ''} encontrada${plural ? 's' : ''}`;
      countEl.classList.remove('filter-count--empty');
    }
  }
}

propCards.forEach(card => {
  card.style.transition = 'opacity 0.35s ease, transform 0.42s cubic-bezier(0.4,0,0.2,1), box-shadow 0.4s ease';
});

// Conteo inicial
applyFilters();

// ===== SEARCH BAR — GLOW EN FOCO =====
const searchBar = document.querySelector('.search__bar');
if (searchBar) {
  searchBar.querySelectorAll('select').forEach(field => {
    field.addEventListener('focus', () => {
      searchBar.style.boxShadow = '0 8px 48px rgba(22, 105, 122, 0.18), 0 0 0 2px rgba(22, 105, 122, 0.1)';
    });
    field.addEventListener('blur', () => {
      searchBar.style.boxShadow = '';
    });
  });
}

// ===== FORM SUBMIT — FEEDBACK VISUAL =====
const contactForm = document.querySelector('.contact__form');
if (contactForm) {
  contactForm.addEventListener('submit', (e) => {
    e.preventDefault();
    const submitBtn = contactForm.querySelector('.btn--primary');
    if (!submitBtn) return;
    submitBtn.textContent  = '¡Mensaje enviado!';
    submitBtn.style.background = 'var(--teal)';
    setTimeout(() => {
      submitBtn.textContent      = 'Enviar mensaje';
      submitBtn.style.background = '';
    }, 3200);
  });
}

// ===== WHATSAPP INTELIGENTE — Mensaje con datos de la propiedad =====
function buildWaMessage(card) {
  const title    = card.querySelector('.catalog-card__title')?.textContent?.trim() || '';
  const locEl    = card.querySelector('.catalog-card__location');
  // Quitar el SVG del texto de ubicación
  const location = locEl ? locEl.innerText?.trim() || locEl.textContent?.trim() : '';
  const priceEl  = card.querySelector('.catalog-card__price');
  const price    = priceEl ? priceEl.innerText?.trim() || priceEl.textContent?.trim() : '';
  const specs    = Array.from(card.querySelectorAll('.spec span'))
                        .map(s => s.textContent.trim())
                        .filter(Boolean)
                        .join(' · ');
  const tipo     = card.dataset.type === 'alquiler' ? '🔑 Alquiler' : '🏷️ Venta';

  return (
    `¡Hola Juliana! Vi en MJ Group Real Estate una propiedad que me interesa:\n\n` +
    `🏠 ${title}\n` +
    `📍 ${location}\n` +
    `💰 ${price}\n` +
    `📐 ${specs}\n` +
    `${tipo}\n\n` +
    `¿Podrías darme más información?`
  );
}

document.querySelectorAll('.prop-card__wa').forEach(btn => {
  const setHref = () => {
    const card = btn.closest('.catalog-card');
    if (!card) return;
    const msg = buildWaMessage(card);
    btn.href   = `https://wa.me/573218292749?text=${encodeURIComponent(msg)}`;
    btn.target = '_blank';
    btn.rel    = 'noopener';
  };
  btn.addEventListener('mousedown',  setHref);
  btn.addEventListener('touchstart', setHref, { passive: true });
});

// ===== DESACTIVAR TILT Y MAGNÉTICO EN TOUCH =====
const isTouchDevice = () => window.matchMedia('(hover: none)').matches;
